import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

interface IThemeState {
  themeMode: 'light' | 'dark';
  fontSize: 'sm' | 'md' | 'lg';
}

const initialState: IThemeState = {
  themeMode: 'light',
  fontSize: 'md',
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    themeSwitchMode: (state): IThemeState => ({
      ...state,
      themeMode: state.themeMode === 'dark' ? 'light' : 'dark',
    }),
    themeIncrementFont: (state): IThemeState => ({
      ...state,
      fontSize:
        state.fontSize === 'sm' ? 'md' : state.fontSize === 'md' ? 'lg' : 'sm',
    }),
    themePatch: (
      state,
      action: PayloadAction<Optional<IThemeState, 'themeMode' | 'fontSize'>>,
    ): IThemeState => ({
      ...state,
      ...action.payload,
    }),
    themePut: (_state, action: PayloadAction<IThemeState>): IThemeState =>
      action.payload,
  },
});

export const { themeSwitchMode, themeIncrementFont, themePatch, themePut } =
  themeSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.plivo.value)`
export const selectTheme = (state: RootState) => state.theme;

export const themeReducer = themeSlice.reducer;
